module.exports = __webpack_public_path__ + "img/amex.13296518.svg";